import React, { useEffect, useRef } from 'react';
import autosize from 'autosize';
import TooltipButton from '../../tooltip/Popover';
import './textbox.css'

const Textbox = ({
  label,
  placeholder,
  value,
  onChange,
  onClick,
  required,
  readOnly,
  wordboundation = { limit: undefined },
  labelStyle = { fontWeight: "500", color:"black" },
  htmlFor,
  fieldName,
  textstyle,
  ismargin,
  mbset=true,
  isextra,
  rowlength
}) => {
  const rowheight = rowlength ? rowlength : 1
  const textarearef = useRef(null);
  
useEffect(() => {
  if (textarearef?.current) {
    autosize(textarearef?.current);
    textarearef.current?.blur();
  }

  return () => {
    if (textarearef?.current) {
      autosize?.destroy(textarearef.current);
    }
  };
}, []);

useEffect(() => {
  if (textarearef.current) {
    autosize.update(textarearef.current);
  }
}, [value]);
const capitalizeLogic = (text) => {
  if (!text) return text;
  return text.charAt(0).toUpperCase() + text.slice(1);
};

  const handleChange = (e) => {
    let newText = e.target.value;
    let words = newText.trim().split(/\s+/);

    if (wordboundation?.limit && words.length > wordboundation.limit) {
      words = words.slice(0, wordboundation.limit);
      newText = words.join(' ');
    }
    newText = capitalizeLogic(newText);
    const syntheticEvent = {
      ...e,
      target: {
        ...e.target,
        value: newText,
      },
    };

    onChange(syntheticEvent);
  };

useEffect(() => {
  if (textarearef?.current) {
    setTimeout(() => {
      textarearef?.current?.blur();
    }, 0);
  }
}, []);

  return (
    <div className={`${mbset ? "mb-2":"" } `} style={{marginTop:ismargin && "10px"}}>
      {label && 
      
        <div className="d-flex justify-content-between ">
        <label htmlFor={htmlFor} style={labelStyle}>
<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' ,}}>
  <div style={{ display: 'flex', alignItems: 'center', lineHeight: '1', height: '100%',width:"100%" }}>
    <span style={{ display: 'flex', alignItems: 'center' }}>{label}</span>
    {required && (
      <span style={{ color: 'red', fontSize: '18px', paddingLeft: '5px' }}>*</span>
    )}
    {
      fieldName &&   <span style={{paddingLeft:"10px", display: 'flex', alignItems: 'center' }}>
      <TooltipButton fieldName={fieldName} />
    </span>
    }
  
  </div>
</div>
</label>
{wordboundation?.limit && (
        <small   id={`word${wordboundation.id}`} style={{ fontSize: '14px', color: 'gray' }} className={value > wordboundation.limit ? 'text-danger' : 'text-muted'}>
          {value.length} / {wordboundation.limit}
        </small>
      )}     
        </div>     
        }
      <textarea
        ref={textarearef}
        
        placeholder={placeholder}
        rows={rowheight}
        value={value}
        className={`${isextra ? "custominputformtextareaextra": "custominputformtextarea"} form-control `}
        onChange={handleChange}
        onClick={onClick}
        required={required}
        readOnly={readOnly}
        maxLength={wordboundation.limit}
        style={textstyle}
      />
    </div>
  );
};

export default Textbox;
